import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, catchError, throwError } from 'rxjs';
import { environment } from '@env/environment';
import { Microservice } from '@hypenation/shared';

export interface InitiateAuthRequest {
  email?: string;
  username?: string;
  hacMemberNumber?: string;
}

export interface InitiateAuthResponse {
  message: string;
  reference: string;
  success: boolean;
}

export interface AuthenticateRequest {
  email?: string;
  username?: string;
  otp: string;
}

export interface AuthenticateResponse {
  accessToken: string;
  refreshToken: string;
  tokenType: string;
  expiresIn: number;
}

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  private readonly apiUrl = environment.apiUrl;

  constructor(private readonly _http: HttpClient) {}

  /**
   * Initiates authentication by sending OTP to email/username/hacMemberNumber
   */
  public initiateAuthentication(
    request: InitiateAuthRequest
  ): Observable<HttpResponse<InitiateAuthResponse>> {
    const httpOptions = {
      headers: new HttpHeaders({
        Accept: '*/*',
        'Content-Type': 'application/json',
      }),
      observe: 'response' as const,
    };

    return this._http
      .post<InitiateAuthResponse>(
        `${this.apiUrl}/${Microservice.IAM}/oauth/otp/initiate`,
        request,
        httpOptions
      )
      .pipe(
        catchError((error: Error) => {
          return throwError(() => error);
        })
      );
  }

  /**
   * Authenticates with OTP and returns access tokens
   */
  public authenticate(
    request: AuthenticateRequest
  ): Observable<HttpResponse<AuthenticateResponse>> {
    const httpOptions = {
      headers: new HttpHeaders({
        Accept: '*/*',
        'Content-Type': 'application/json',
      }),
      observe: 'response' as const,
    };

    return this._http
      .post<AuthenticateResponse>(
        `${this.apiUrl}/${Microservice.IAM}/oauth/otp/authenticate`,
        request,
        httpOptions
      )
      .pipe(
        catchError((error: Error) => {
          return throwError(() => error);
        })
      );
  }
}

